module.exports = __webpack_public_path__ + "static/media/powerpoint.370380d5.svg";